import { usePage } from "@inertiajs/react"

import type { SharedProps } from "@/types"

/**
 * OKS-37 — Reads the `unread_messages_count` shared prop emitted by
 * `ApplicationController#inertia_share`. Cap is 99 (server-side via
 * `Conversations::UnreadCount::MAX_COUNT`); the FE renders `99+`
 * past the cap.
 *
 * Returns 0 on pages where the shared prop is absent (anon / pre-
 * brand-context / public surfaces).
 */
export function useUnreadMessagesCount(): number {
  const page = usePage<Partial<SharedProps>>()
  const value = page.props.unread_messages_count
  if (typeof value !== "number" || Number.isNaN(value)) return 0
  return value
}
